import React, { useState } from "react";
import { Button, Form, Input, Radio } from "antd";
import { component_tool, framework_tool } from '@/tool'
let { WizFileUpload } = framework_tool;
let { Wizmessage } = component_tool;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

const Audit = ({ form, data, submit, cancel, ...props }) => {

  const [type, setType] = useState(data.fileType)
  const { getFieldDecorator, validateFields, setFields, resetFields, getFieldsValue } = form

  const _submit = (pass) => {
    if (pass === 3) {
      cancel && cancel()
      resetFields()
      return;
    } else {
    validateFields((err, values) => {
      if (!err) {

          if (values.name && (values.fileId || values.address)) {
            values.fileName = values.fileId ? values.fileId[0].fileOriginalName : ''
            submit && submit({ ...values });
            resetFields()
          } else {
            Wizmessage.error('请将课程内容填写完整');
          }
      }
    });
  }

  }

  formatLink = ({ fileType, fileName, fileId, address }) => {
    let newFileId = getOssFilePath(fileId[0]?.fileId || '')
    if (fileType == 0) {
      return <a href={newFileId}>
        {fileName}
      </a>
    } else {
      return address
    }
  }

  const { contentType, orderNum, name, fileType = 0, address, fileId = '', isRead } = data || {}
  console.log(data, 'datatada')
  return (
    <Form {...formItemLayout}>
      {getFieldDecorator('contentType', { initialValue: contentType })}
      {getFieldDecorator('orderNum', { initialValue: orderNum })}
      {contentType == 1 ? <>{getFieldDecorator('fileType', { initialValue: fileType })}</> : null}
      <Form.Item label={contentType == 0 ? "课件名称" : "考试名称"}>
        {!isRead ?
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{ required: true, message: '请输入'}],
          })(<Input placeholder='请输入' maxLength={50} />)
          : name
        }
      </Form.Item>
      {contentType == 0 ?
        <>
          <Form.Item label="课件上传">
            {!isRead ?
              getFieldDecorator('fileType', {
                initialValue: fileType,
                rules: [{ required: true, message: ''}],
              })(<Radio.Group onChange={(e) => {
                setType(e.target.value)
              }} value={type}>
                <Radio value={0}>文件上传</Radio>
                <Radio value={1}>文件地址</Radio>
              </Radio.Group>)
              : formatLink(data)
            }
          </Form.Item>
          {!isRead ? getFieldsValue().fileType == 0 ? <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
            {
              getFieldDecorator('fileId', {
                initialValue: fileId,
                rules: [{ required: true, message: '请上传'}],
              })(<WizFileUpload
                accept={'.zip,.rar,.mp4'}
                listType={'text'}
                limit={-1}
                courseType={type}
                uploadType={'courseWare'}
                // beforeUpload={(file) => {
                //   let result = true;
                //   if (file.type.indexOf('application/x-zip-compressed') == -1 &&
                //     file.type.indexOf('application/zip') == -1
                //   ) {
                //     Wizmessage.error('只能上传zip文件,请重新选择!');
                //     result = false;
                //   }
                //   return result;
                // }}
                progress={{
                  strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068',
                  },
                  strokeWidth: 3,
                  format: percent => `${parseFloat(percent.toFixed(2))}%`,
                }}
              />)
            }
          </Form.Item>
            :
            <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
              {
                getFieldDecorator('address', {
                  initialValue: address,
                  rules: [{ required: true, message: '请输入'}],
                })(<Input.TextArea placeholder='文件地址' maxLength={200} autoSize={{ minRows: 3, maxRows: 6 }} />)
              }
            </Form.Item>
            : null
          }</> :
        <>
          <Form.Item label="考试上传">
            {!isRead ?
              getFieldDecorator('fileId', {
                initialValue: fileId,
                rules: [{ required: true, message: '请上传'}],
              })(<WizFileUpload
                accept={'.xlsx,.xls'}
                listType={'text'}
                limit={-1}
                courseType={type}
                uploadType={'courseWare'}
                progress={{
                  strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068',
                  },
                  strokeWidth: 3,
                  format: percent => `${parseFloat(percent.toFixed(2))}%`,
                }}
              />)
              : formatLink(data)
            }
          </Form.Item>
        </>
      }
      {!isRead ?
        <Form.Item wrapperCol={{ span: formItemLayout?.wrapperCol?.span, offset: formItemLayout?.labelCol?.span }}>
          <Button type='primary' onClick={() => _submit(2)}>确定</Button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => _submit(3)}>取消</Button>
        </Form.Item>
        : null}
    </Form>
  )
}

let AuditForm = Form.create()(Audit)
export {
  AuditForm,
}

